export default "__VITE_ASSET__C1MV9vg5__"